import * as React from "react";
function SvgCheckmark(props, svgRef) {
  return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 17.837 17.837" ref={svgRef} {...props}><g style={{
      fill: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27 c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0 L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "src/assets/icons/checkmark.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/checkmark_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/checkmark_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/checkmark_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/checkmark_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/checkmark_4x.svg"
};
export { ForwardRef as ReactComponent };